// @flow

import React, { Component, Fragment } from 'react';
import { autorun, toJS } from 'mobx';
import { observer } from 'mobx-react';
import cx from 'classnames';
import t from '~/src/services/i18n';
import { Link } from 'react-router-dom';
import { Image, Transformation } from 'cloudinary-react';
import { UPLOAD_WIDGET_CONFIG } from '~/src/config/galleries';
import PageIntro from '~/src/components/PageIntro';
import trackEvent from '~/src/services/analytics';

declare var cloudinary: any;

import './DynamicUrl.scss';

type Props = {
  config: Object,
  code: string,
  setWaterMarkAsset: Function,
  setColor: Function,
  text: string,
  color: string,
  waterMarkAsset: ?Object,
  setText: Function
}

const colors = [
  { name: 'Light Blue', hex: '#7CA9CB' },
  { name: 'Orange', hex: '#D79025' },
  { name: 'Green', hex: '#008000' },
  { name: 'Pink', hex: '#e91e63' },
  { name: 'Purple', hex: '#9c27b0' },
];

const eventNames = {
  color: 'edit image color',
  text: 'edit overlay text',
};

const colorUrl = (url) => {
  // URL Syntax highlight - split URL parts
  const urlParts = url.split('/');
  const coloredUrl = urlParts.reduce((accumulator, currentValue, currentIndex, array) => {
    let color;
    // This counts URL parts starting from the end
    switch (array.length - currentIndex) {
      case 6:
      case 7:
        color = '#F2D864'; // Logo (image) overlay
        break;
      case 8:
        color = '#98c2e4'; // Text overlay
        break;
      case 9:
      case 10:
        color = '#DC8326'; // Color replace
        break;
    }
    return (
      // $FlowFixMe
      <Fragment>
        {accumulator}{color ? (<span style={{ color: color }}>/{currentValue}</span>) : '/' + currentValue}
      </Fragment>
    );
  });
  return coloredUrl;
};

@observer
class DynamicUrl extends Component<Props> {
  init: boolean = false;
  myWidget: Object = {};
  myUploadWidget: Object = {};
  updateConfigDisposer: Function = false;
  urlSample: string = colorUrl(this.props.code);

  componentDidMount() {
    const { config } = this.props;

    this.myWidget = cloudinary.galleryWidget(toJS(config));
    this.myWidget.render();
    if (this.myWidget.element) {
      this.urlSample = colorUrl(this.myWidget.element.getElementsByTagName('img')[0].src);
    }

    const updateWidget = (config) => {

      this.myWidget = cloudinary.galleryWidget(config);
      this.myWidget.render();

      // Update the sample URL
      this.urlSample = colorUrl(
        this.myWidget.cloudinaryCore.getImageUrl(
          'v1/Product%20gallery%20demo/New%20Demo%20Pages/Tshirt/tshirt1',
          600,
          600,
          config.transformation
        )
      );

    };

    this.updateConfigDisposer = autorun(() => {
      const transformation = toJS(this.props.config.transformation);
      if (this.init && transformation) {
        const config = toJS(this.props.config);
        updateWidget(config);
      }
      this.init = true;
    });

  }

  componentWillUnmount() {
    if (this.updateConfigDisposer) {
      this.updateConfigDisposer();
    }
    this.myWidget.destroy();
  }

  openUploadWidget = () => {
    const { setWaterMarkAsset } = this.props;

    trackEvent({ action: 'upload', label: 'intent to upload watermark' });
    this.myUploadWidget = cloudinary.openUploadWidget(
      UPLOAD_WIDGET_CONFIG,
      (error, result) => {
        if (result && result.event === 'success') {
          this.myUploadWidget.close({ quiet: true });
          setWaterMarkAsset(result.info);
          trackEvent({ action: 'upload', label: 'upload watermark successfully' });
        }
      }
    );
  }

  removeWaterMarkAsset = () => {
    this.props.setWaterMarkAsset(null);
    trackEvent({ action: 'remove', label: 'removed watermark successfully' });
  }

  setValue = (key: string, val: string, name?: string) => {
    if (key == 'color') {
      this.props.setColor(val);
    }
    if (key == 'text') {
      this.props.setText(val);
    }
    trackEvent({ action: eventNames[key], label: name });
  }

  render() {
    return (
      <div className="section dynamic-url">
        <PageIntro page={'transformation'} />
        <h1>{t('easyToCustomize')}</h1>
        <div className="content">
          <div className="gallery">
            <div id="dynamic-url-gallery"></div>
            <pre className="url-sample">
              {this.urlSample}
            </pre>
          </div>
          <div className="gallery-settings">
            <div className="image-transformation highlight-box">
              <div className="transformation-box color-pickers">
                <h3>{t('replaceShirtColor')}</h3>
                {colors.map((color) =>
                  <label className="color-picker" key={color.hex}>
                    <button
                      onClick={() => this.setValue('color', color.hex, color.name)}
                      className={cx('color-box', { 'selected': this.props.color == color.hex })}
                      style={{ background: color.hex }}
                    />
                    {color.name}
                  </label>
                )}
              </div>
              <div className="transformation-box text">
                <h3>{t('embedText')}</h3>
                <input
                  type="text"
                  onChange={e => this.setValue('text', e.target.value)}
                  defaultValue={decodeURIComponent(this.props.text)}
                  maxLength="20"
                />
              </div>
              <div className="transformation-box watermark">
                <h3>{t('watermark')}</h3>
                <Link id="upload_widget_opener" to="/" className="btn btn-small btn-secondary btn-icon" onClick={e => {
                  e.preventDefault();
                  e.stopPropagation();
                  this.openUploadWidget();
                }}>
                  {t('upload')}
                </Link>
                <div className="uploaded-images">
                  {this.props.waterMarkAsset && this.props.waterMarkAsset.public_id &&
                    <div className="uploaded-image">
                      <Image cloudName="demo" publicId={this.props.waterMarkAsset.public_id} width={80} height={80} crop={'pad'} >
                        <Transformation radius="40" />
                      </Image>
                      <button
                        onClick={this.removeWaterMarkAsset}
                      >
                        {t('remove')}
                      </button>
                    </div>
                  }
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    );
  }
}

export default DynamicUrl;
